import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'

// TODO move me somewhere central
interface ApiResponse {
  success: boolean
  messages: string[]
}
//

interface PolicyRule {
  rule_name: string
  rule_title: string
  rule_description: string
  rule_severity: string
  ruleSeverityLabel: string
  dev_enabled: boolean
  qa_enabled: boolean
  prod_enabled: boolean
}
interface ApplicationPoliciesArgs {
  orgUuid: string
  appUuid: string
}
interface ApplicationPoliciesResponse extends ApiResponse {
  configs: PolicyRule[]
}

export async function getApplicationPolicies(
  this: ThisConnector,
  { orgUuid, appUuid }: ApplicationPoliciesArgs
) {
  return this.connector.get(`/${orgUuid}/assess/rules/configs/app/${appUuid}`)
}

export const useApplicationPolicies = ({
  orgUuid,
  appUuid
}: ApplicationPoliciesArgs) => {
  const { isLoading, error, data } = useContrastQuery<
    ApplicationPoliciesArgs,
    ApplicationPoliciesResponse
  >([Query.APPLICATION_POLICIES, orgUuid, appUuid], getApplicationPolicies, {
    orgUuid,
    appUuid
  })

  return {
    isLoading,
    error,
    data
  }
}
